module.exports = __webpack_public_path__ + "static/media/close2.29f1252e.svg";